import getComponentByType from "./utils";

export default getComponentByType;
